module.exports = __webpack_public_path__ + "static/media/ticket.4e5d4fae.svg";